/* eslint-disable rulesdir/imports */
/* eslint-disable monorepo/no-internal-import */
'use client';

import ActionButtonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ActionButton.svg';
import ActionGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ActionGroup.svg';
import BadgeSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Badge.svg';
import BreadcrumbsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Breadcrumbs.svg';
import ButtonGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ButtonGroup.svg';
import ButtonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Button.svg';
import CalendarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Calendar.svg';
import {Card, CardPreview, CardView, Collection, Content, Text} from '@react-spectrum/s2';
import CheckboxGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/CheckboxGroup.svg';
import CheckboxSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Checkbox.svg';
import CollectionsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Collections.svg';
import ColorAreaSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorArea.svg';
import ColorFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorField.svg';
import ColorPickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorPicker.svg';
import ColorSliderSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorSlider.svg';
import ColorSwatchPickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatchPicker.svg';
import ColorSwatchSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatch.svg';
import ColorWheelSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorWheel.svg';
import ComboBoxSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ComboBox.svg';
import ComingSoonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ComingSoon.svg';
import ContextualHelpSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ContextualHelp.svg';
import DateFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DateField.svg';
import DatePickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DatePicker.svg';
import DateRangePickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DateRangePicker.svg';
import DialogSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Dialog.svg';
import DisclosureGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DisclosureGroup.svg';
import DisclosureSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Disclosure.svg';
import DragAndDropSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DragAndDrop.svg';
import DropZoneSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DropZone.svg';
import FileTriggerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/FileTrigger.svg';
import FocusScopeSvg from '@react-spectrum/docs/pages/assets/component-illustrations/FocusScope.svg';
import FormSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Form.svg';
import InputSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Input.svg';
import InternationalizedDateSvg from '@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDate.svg';
import {Key} from 'react-aria-components';
import LabeledValueSvg from '@react-spectrum/docs/pages/assets/component-illustrations/LabeledValue.svg';
import LabelSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Label.svg';
import LinkSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Link.svg';
import ListBoxSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ListBox.svg';
import ListViewSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ListView.svg';
import mcpSvg from './icons/mcp.svg';
import MenuSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Menu.svg';
import MeterSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Meter.svg';
import NumberFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/NumberField.svg';
import PickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Picker.svg';
import PopoverSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Popover.svg';
import ProgressBarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ProgressBar.svg';
import ProgressCircleSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ProgressCircle.svg';
import RadioGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/RadioGroup.svg';
import RangeCalendarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/RangeCalendar.svg';
import RangeSliderSvg from '@react-spectrum/docs/pages/assets/component-illustrations/RangeSlider.svg';
import React from 'react';
import SearchFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/SearchField.svg';
import SelectionSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Selection.svg';
import SliderSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Slider.svg';
import StatusLightSvg from '@react-spectrum/docs/pages/assets/component-illustrations/StatusLight.svg';
import {style} from '@react-spectrum/s2/style' with { type: 'macro' };
import SwitchSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Switch.svg';
import TableSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Table.svg';
import TabsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Tabs.svg';
import TagGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TagGroup.svg';
import TextAreaSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TextArea.svg';
import TextFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TextField.svg';
import TimeFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TimeField.svg';
import ToastSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Toast.svg';
import ToggleButtonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ToggleButton.svg';
import TooltipSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Tooltip.svg';
import TreeSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Tree.svg';
import useFocusRingSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useFocusRing.svg';
import useFocusSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useFocus.svg';
import useFocusWithinSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useFocusWithin.svg';
import useHoverSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useHover.svg';
import useKeyboardSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useKeyboard.svg';
import useLongPressSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useLongPress.svg';
import useMoveSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useMove.svg';
import usePressSvg from '@react-spectrum/docs/pages/assets/component-illustrations/usePress.svg';
export interface ComponentCardItem {
  id: string,
  name: string,
  href: string
}

const componentIllustrations: Record<string, React.ComponentType | undefined> = {
  'Accordion': DisclosureGroupSvg,
  'ActionButton': ActionButtonSvg,
  'ActionButtonGroup': ButtonGroupSvg, // TODO: get better illustration
  'ActionGroup': ActionGroupSvg,
  'ActionMenu': MenuSvg,
  'Badge': BadgeSvg,
  'Breadcrumbs': BreadcrumbsSvg,
  'Button': ButtonSvg,
  'ButtonGroup': ButtonGroupSvg,
  'Calendar': CalendarSvg,
  'Checkbox': CheckboxSvg,
  'CheckboxGroup': CheckboxGroupSvg,
  'Collections': CollectionsSvg,
  'ColorArea': ColorAreaSvg,
  'ColorField': ColorFieldSvg,
  'ColorPicker': ColorPickerSvg,
  'ColorSlider': ColorSliderSvg,
  'ColorSwatch': ColorSwatchSvg,
  'ColorSwatchPicker': ColorSwatchPickerSvg,
  'ColorWheel': ColorWheelSvg,
  'ComboBox': ComboBoxSvg,
  'ContextualHelp': ContextualHelpSvg,
  'DateField': DateFieldSvg,
  'DatePicker': DatePickerSvg,
  'DateRangePicker': DateRangePickerSvg,
  'Dialog': DialogSvg,
  'Disclosure': DisclosureSvg,
  'DisclosureGroup': DisclosureGroupSvg,
  'Drag and Drop': DragAndDropSvg,
  'DropZone': DropZoneSvg,
  'FileTrigger': FileTriggerSvg,
  'FocusScope': FocusScopeSvg,
  'Form': FormSvg,
  'GridList': ListViewSvg, // GridList -> ListView
  'Input': InputSvg,
  'InternationalizedDate': InternationalizedDateSvg,
  'Label': LabelSvg,
  'LabeledValue': LabeledValueSvg,
  'Link': LinkSvg,
  'LinkButton': ButtonSvg, // TODO: get better illustration
  'ListBox': ListBoxSvg,
  'ListView': ListViewSvg,
  'Menu': MenuSvg,
  'Meter': MeterSvg,
  'NumberField': NumberFieldSvg,
  'Picker': PickerSvg,
  'Popover': PopoverSvg,
  'ProgressBar': ProgressBarSvg,
  'ProgressCircle': ProgressCircleSvg,
  'RadioGroup': RadioGroupSvg,
  'RangeCalendar': RangeCalendarSvg,
  'RangeSlider': RangeSliderSvg,
  'SearchField': SearchFieldSvg,
  'Select': PickerSvg, // Select -> Picker
  'Selection': SelectionSvg,
  'Slider': SliderSvg,
  'StatusLight': StatusLightSvg,
  'Switch': SwitchSvg,
  'Table': TableSvg,
  'TableView': TableSvg,
  'Tabs': TabsSvg,
  'TagGroup': TagGroupSvg,
  'TextArea': TextAreaSvg,
  'TextField': TextFieldSvg,
  'TimeField': TimeFieldSvg,
  'Toast': ToastSvg,
  'ToggleButton': ToggleButtonSvg,
  'ToggleButtonGroup': ActionGroupSvg, // ToggleButtonGroup -> ActionGroup
  'Tooltip': TooltipSvg,
  'Tree': TreeSvg,
  'TreeView': TreeSvg,
  'useFocus': useFocusSvg,
  'useFocusRing': useFocusRingSvg,
  'useFocusWithin': useFocusWithinSvg,
  'useHover': useHoverSvg,
  'useKeyboard': useKeyboardSvg,
  'useLongPress': useLongPressSvg,
  'useMove': useMoveSvg,
  'usePress': usePressSvg,
  'MCP Server': mcpSvg
};

// Overrides for specific illustrations so they fit within the cards.
const propOverrides = {
  DateField: {
    viewBox: '0 -56 276 276'
  },
  TimeField: {
    viewBox: '0 -56 276 276'
  },
  DatePicker: {
    style: {alignSelf: 'end', height: 'calc(100% - 16px)'}
  },
  DateRangePicker: {
    style: {alignSelf: 'end', height: 'calc(100% - 16px)'}
  },
  DropZone: {
    viewBox: '0 0 290 220',
    style: {height: 'calc(100% - 16px)'}
  },
  Select: {
    // Safari doesn't calculate the max-height correctly with the aspect-ratio.
    style: {height: 'calc(100% - 16px)'}
  },
  Picker: {
    style: {height: 'calc(100% - 16px)'}
  },
  ComboBox: {
    style: {height: 'calc(100% - 16px)'}
  }
};

const illustrationContainer = style({
  width: 'full',
  aspectRatio: '3/2',
  backgroundColor: '--anatomy-gray-100',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 0
});

const illustrationStyles = style({
  maxWidth: 'calc(100% - 16px)',
  userSelect: 'none',
  pointerEvents: 'none'
});

interface ComponentCardGridProps {
  items: ComponentCardItem[],
  ariaLabel?: string,
  size?: 'S' | 'M' | 'L',
  onAction?: (key: Key) => void,
  styles?: any,
  renderEmptyState?: () => React.ReactNode
}

export function ComponentCardView({items, ariaLabel = 'Items', size = 'S', onAction, styles, renderEmptyState}: ComponentCardGridProps) {
  return (
    <CardView aria-label={ariaLabel} onAction={onAction} styles={styles} renderEmptyState={renderEmptyState}>
      <Collection items={items}>
        {(item) => {
          let IllustrationComponent = componentIllustrations[item.name] || ComingSoonSvg;
          let overrides = propOverrides[item.name] || {};
          return (
            <Card key={item.id} id={item.id} href={item.href} size={size} textValue={item.name}>
              <CardPreview>
                <div className={illustrationContainer}>
                  <IllustrationComponent
                    {...overrides}
                    aria-hidden="true"
                    // @ts-ignore
                    className={illustrationStyles}
                    style={{
                      maxHeight: 'calc(100% - 16px)',
                      ...overrides.style
                    }} />
                </div>
              </CardPreview>
              <Content>
                <Text slot="title">{item.name}</Text>
              </Content>
            </Card>
          );
        }}
      </Collection>
    </CardView>
  );
}
